import { lazy, ReactElement } from 'react';

// Lazy load feature modules for code splitting
const DashboardHome = lazy(() => import('./features/dashboard/DashboardHome'));
const TodoQueue = lazy(() => import('./features/todos/TodoQueue'));
const LeadList = lazy(() => import('./features/leads/LeadList'));
const LeadProfile = lazy(() => import('./features/leads/LeadProfile'));
const ClientList = lazy(() => import('./features/clients/ClientList'));
const ClientProfile = lazy(() => import('./features/clients/ClientProfile'));
const TutorList = lazy(() => import('./features/tutors/TutorList'));
const TutorProfile = lazy(() => import('./features/tutors/TutorProfile'));
const SessionList = lazy(() => import('./features/sessions/SessionList'));
const ReportList = lazy(() => import('./features/reports/ReportList'));
const AssignmentList = lazy(() => import('./features/assignments/AssignmentList'));
const OnlineSessionList = lazy(() => import('./features/online-sessions/OnlineSessionList'));

// Item Catalog
const CatalogHome = lazy(() => import('./features/item-catalog/CatalogHome'));
const ProductList = lazy(() => import('./features/item-catalog/products/ProductList').then(m => ({ default: m.ProductList })));
const ProductForm = lazy(() => import('./features/item-catalog/products/ProductForm').then(m => ({ default: m.ProductForm })));
const InstructorList = lazy(() => import('./features/item-catalog/instructors/InstructorList').then(m => ({ default: m.InstructorList })));
const InstructorForm = lazy(() => import('./features/item-catalog/instructors/InstructorForm').then(m => ({ default: m.InstructorForm })));
const TopicList = lazy(() => import('./features/item-catalog/topics/TopicList').then(m => ({ default: m.TopicList })));
const TopicForm = lazy(() => import('./features/item-catalog/topics/TopicForm').then(m => ({ default: m.TopicForm })));
const CreditConversion = lazy(() => import('./features/item-catalog/credit-conversion/CreditConversion').then(m => ({ default: m.CreditConversion })));

interface RouteConfig {
  path: string;
  element: ReactElement;
  permission?: {
    action: string;
    subject: string;
  };
}

export const routes: RouteConfig[] = [
  // Dashboard
  {
    path: '/',
    element: <DashboardHome />,
  },

  // Todos
  {
    path: '/todos',
    element: <TodoQueue />,
  },

  // Leads
  {
    path: '/leads',
    element: <LeadList />,
  },
  {
    path: '/leads/new',
    element: <LeadProfile isNew />,
  },
  {
    path: '/leads/:id',
    element: <LeadProfile />,
  },

  // Clients
  {
    path: '/clients',
    element: <ClientList />,
  },
  {
    path: '/clients/new',
    element: <ClientProfile isNew />,
  },
  {
    path: '/clients/:id',
    element: <ClientProfile />,
  },

  // Tutors
  {
    path: '/tutors',
    element: <TutorList />,
  },
  {
    path: '/tutors/:uuid',
    element: <TutorProfile />,
  },

  // Assignments
  {
    path: '/assignments',
    element: <AssignmentList />,
  },

  // Sessions (in-person)
  {
    path: '/sessions',
    element: <SessionList />,
  },

  // Online Sessions (VTOP)
  {
    path: '/online-sessions',
    element: <OnlineSessionList />,
  },

  // Reports
  {
    path: '/reports',
    element: <ReportList />,
  },
  {
    path: '/reports/:reportType',
    element: <ReportList />,
  },

  // Item Catalog
  {
    path: '/catalog',
    element: <CatalogHome />,
  },
  // Products
  {
    path: '/catalog/products',
    element: <ProductList />,
  },
  {
    path: '/catalog/products/new',
    element: <ProductForm />,
  },
  {
    path: '/catalog/products/:id',
    element: <ProductForm />,
  },
  {
    path: '/catalog/products/:id/edit',
    element: <ProductForm />,
  },
  // Instructors
  {
    path: '/catalog/instructors',
    element: <InstructorList />,
  },
  {
    path: '/catalog/instructors/new',
    element: <InstructorForm />,
  },
  {
    path: '/catalog/instructors/:id',
    element: <InstructorForm />,
  },
  {
    path: '/catalog/instructors/:id/edit',
    element: <InstructorForm />,
  },
  // Topics
  {
    path: '/catalog/topics',
    element: <TopicList />,
  },
  {
    path: '/catalog/topics/new',
    element: <TopicForm />,
  },
  {
    path: '/catalog/topics/:id/edit',
    element: <TopicForm />,
  },
  // Credit Conversion
  {
    path: '/catalog/credit-conversion',
    element: <CreditConversion />,
  },
];
